import { Agent, CreateAgentRequest, UpdateAgentRequest } from '../types';
import { PaginationParams } from '../core/http';
import { BaseService } from './BaseService';

export class AgentService extends BaseService<
  Agent,
  CreateAgentRequest,
  UpdateAgentRequest
> {
  constructor() {
    super('/v1/agents');
  }

  async getByOrganization(
    organizationId: number,
    pagination?: PaginationParams
  ): Promise<Agent[]> {
    const response = await this.getAll({
      organization_id: organizationId,
      ...pagination,
    });
    return response.items;
  }

  async getActiveByOrganization(
    organizationId: number,
    pagination?: PaginationParams
  ): Promise<Agent[]> {
    const response = await this.getAll({
      organization_id: organizationId,
      is_active: true,
      ...pagination,
    });
    return response.items;
  }

  async getByName(
    name: string,
    organizationId?: number
  ): Promise<Agent | null> {
    try {
      const params: any = { name };
      if (organizationId) {
        params.organization_id = organizationId;
      }
      const response = await this.getAll(params);
      return response.items[0] || null;
    } catch (error) {
      return null;
    }
  }
}
